import React from 'react';
import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import InstanceForm from '../Shared/InstanceForm';
import {instanceDocumentTitle} from '../instanceHelpers';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const EditInstancePage: React.FC = () => {
  useSetDocumentTitle(instanceDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && <InstanceForm id={Number(id)} mode="edit" />}
    </ContentWrapper>
  );
};

export default EditInstancePage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InstancesEdit(':id'),
  element: <EditInstancePage />,
  isPrivate: true,
  requireSuperAdmin: true,
});
